// override how Date is serialized once globally with a custom toJSON() that uses local time:
// This affects all JSON.stringify() calls for Date, including those by libraries like NSwag-generated clients.

var __ksaJsonPatched = false;

export function patchDateToJson(): void {
  if (!__ksaJsonPatched) {
    const pad = (n: number) => (n < 10 ? '0' + n : n);

    var formatLocalIso = function (this: Date): string {
      return `${this.getFullYear()}-${pad(this.getMonth() + 1)}-${pad(this.getDate())}T${pad(this.getHours())}:${pad(
        this.getMinutes()
      )}:${pad(this.getSeconds())}.${this.getMilliseconds().toString().padStart(3, '0')}`;
    };

    Date.prototype.toJSON = formatLocalIso;
    Date.prototype.toISOString = formatLocalIso;

    __ksaJsonPatched = true;
  }
}
